import { kitResultsViewable } from '@repo/utils';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useImpersonate from 'services/auth/useImpersonate';

const toastWarning =
  'Your note will not be visible until results are released.';
const bannerWarning =
  'This note will not be visible to your patient until results are released.';

export default function usePractitionerNoteWarning() {
  const { impersonateId } = useImpersonate();
  const { currentKit } = useCurrentKitAndTinyAccount();

  const patientCanSeeResults = kitResultsViewable(currentKit);

  const shouldShowWarning = !!impersonateId && !patientCanSeeResults;

  return {
    shouldShowWarning,
    toastWarning,
    bannerWarning,
  };
}
